import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild  } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnChanges {
  @Input() doneItems;
  @Input() totalItems;

  @Output() isProgressComplete: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Current progress in percentage.
   */
  private currentProgress = 0;
  private prevDoneItems = this.doneItems;

  @ViewChild('progress') progress: ElementRef;

  constructor() { }

  ngOnChanges() {
    if (this.doneItems !== this.prevDoneItems) {
      this.currentProgress = (this.doneItems / this.totalItems) * 100;
      this.progress.nativeElement.style.width = this.currentProgress + '%';
      this.prevDoneItems = this.doneItems;
    }
    if (this.currentProgress === 100) {
      this.isProgressComplete.emit(true);
    }
  }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/progress-bar/progress-bar.component.ts